"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentsBubble = void 0;
const tslib_1 = require("tslib");
const CommentCountElement_1 = require("../../webComponents/CommentCountElement");
const TextBubbleCSS_1 = require("./TextBubbleCSS");
/**
 * Displaying comments bubble with icon
 */
class CommentsBubble {
    constructor(scene, stylesAlias, isMultiplayer, textBubbleController) {
        this.iconWidth = 0;
        this.iconHeight = 0;
        this.isVisible = true;
        this.gameplayScene = scene;
        this._stylesAlias = stylesAlias;
        this._isMultiplayer = isMultiplayer;
        this.textBubbleController = textBubbleController;
    }
    /**
     * @param text number of comments
     */
    init(text) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const globalStyles = TextBubbleCSS_1.TextBubbleCSS.getCommentsButtonCSSByAlias(this._stylesAlias);
            const html = `
            <div class="comments-button">
                <div class="comments-icon"></div>
                <div class="comments-counter">${text}</div>
            </div>
        `;
            this.commentsCountElement = new CommentCountElement_1.CommentsCountElement({
                template: html,
                styles: globalStyles,
            });
            // TODO: move .is-multiplayer to the top domLayer
            this.commentsCountElement.classList.toggle('is-multiplayer', this._isMultiplayer);
            (_a = this.gameplayScene.getGameplayRenderer()) === null || _a === void 0 ? void 0 : _a.domLayer.appendChild(this.commentsCountElement);
            const commentsContainer = this.commentsCountElement.getCommentsButton();
            if (commentsContainer) {
                commentsContainer.setAttribute('hidden', `${!this.isVisible}`);
                commentsContainer.addEventListener('click', () => {
                    if (!this.clickCallback) {
                        return;
                    }
                    this.clickCallback();
                });
            }
        });
    }
    setClickCallback(clickCallback) {
        this.clickCallback = clickCallback;
    }
    setCommentsVisible(isVisible = true) {
        var _a;
        this.isVisible = isVisible;
        (_a = this.commentsCountElement) === null || _a === void 0 ? void 0 : _a.classList.toggle('is-hidden', !isVisible);
    }
    destroy() {
        var _a;
        if (!this.commentsCountElement) {
            return;
        }
        try {
            (_a = this.gameplayScene.getGameplayRenderer()) === null || _a === void 0 ? void 0 : _a.domLayer.removeChild(this.commentsCountElement);
        }
        catch (e) {
        }
        this.commentsCountElement.cleanShadowRoot();
    }
    updateCommentsCount(text) {
        var _a;
        const commentsCounter = (_a = this.commentsCountElement) === null || _a === void 0 ? void 0 : _a.getCommentsCounter();
        if (commentsCounter) {
            commentsCounter.textContent = `${text}`;
        }
    }
    updateStylesAlias(stylesAlias) {
        this._stylesAlias = stylesAlias;
        if (!this.commentsCountElement) {
            return;
        }
        const globalStyles = TextBubbleCSS_1.TextBubbleCSS.getCommentsButtonCSSByAlias(this._stylesAlias);
        this.commentsCountElement.styles = globalStyles;
    }
}
exports.CommentsBubble = CommentsBubble;
